<template>
  <vue-title :title="tituloCadastro"/>
  <ModalAceites :tipo_aceite="tipoAceite" v-model:abrirModal="openModalAceite" v-if="openModalAceite"/>
  <div class="modal-comprovante none" id="modal-comprovante">
    <div class="container_cadastro_base aletar-senha">
      <div class="div-codigo div-codigo-modal-altera base-senha">
        <form method="post" @submit.prevent="alterarSenha($event)" class="form-senha">
          <div class="divisoes-forms div-senha">
            <label class="label-titulo" for="nm_senha_atual">SENHA ATUAL</label>
            <input type="password" id="nm_senha_atual"
                   @change="verificaCamposSenhas(this.nm_senha_atual, $event)"
                   v-model.trim="nm_senha_atual"
                   class="letra_minusculas"
                   @keydown.enter.prevent
                   placeholder="Digite sua senha atual aqui"
                   tabindex="20">
            <span v-show="nm_senha_atual_span" class="span_retorno"
                  :style="senha_atual_style">{{ texto_senha_atual }}</span>
          </div>
          <div class="divisoes-forms div-senha">
            <label class="label-titulo" for="nm_senha_atualiza">NOVA SENHA</label>
            <Password
                id="nm_senha_atualiza"
                name="nm_senha_atualiza"
                class="input-form letra_minusculas"
                placeholder="Digite sua senha"
                minlength="6"
                maxlength="40"
                @keydown.enter.prevent
                @keyup="verificaSenha"
                v-model.trim="nm_senha_nova"
                tabindex="3"
                prompt-label="Digite sua senha"
                weak-label="Fraca"
                medium-label="Média"
                strong-label="Forte"
                toggleMask
                strong-regex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_])(?=.{6,})"
                required>
              <template #header>
                <h6>Digite sua senha</h6>
              </template>
              <template #footer>
                <Divider/>
                <p class="mt-2">Obrigatório ter:</p>
                <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5 !important;">
                  <li>Pelo menos uma minúscula</li>
                  <li>Pelo menos uma maiúscula</li>
                  <li>Pelo menos um número</li>
                  <li>Pelo menos um caracter especial</li>
                  <li>Mínimo de 6 caracteres</li>
                </ul>
              </template>
            </Password>
            <span id="password-status-altera" class="span_retorno"></span>
          </div>
          <div class="divisoes-forms div-senha">
            <label class="label-titulo" for="verifica_senha_atualiza">CONFIRMAR NOVA SENHA</label>
            <input type="password"
                   id="verifica_senha_atualiza"
                   name="verifica_senha_atualiza"
                   class="input-form letra_minusculas"
                   @keydown.enter.prevent
                   placeholder="Confirme sua senha"
                   @change="comparaSenha(); verificaCamposSenhas(this.nm_senha_verifica_nova)"
                   v-model.trim="nm_senha_verifica_nova"
                   tabindex="22"
                   required>
            <strong style="font-size: small; color: red">
                <span class="span_retorno verifica-senha-nova" v-show="comp_senha">
                  {{ comp_senha ? 'Senhas não conferem' : 'Campo é obrigatório' }}
                </span>
            </strong>
          </div>
          <div class="botoes-valida-reenvia base-botoes-modal-altera">
            <button type="submit"
                    class="botao-modal-altera-senha altera-senha"
                    :disabled="senhaModalCompletadas"
                    :style="senhaModalErradaStyle"
                    tabindex="23"
            >ALTERAR
            </button>
            <button type="button"
                    class="botao-modal-altera-senha"
                    id="fechaModalAletacaoSenha"
                    tabindex="24">FECHAR
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <BarraPassos
    :nome_passo="ehBarraEdicao()"
    :situacao_um="situacaoatual"
    :posicao_um="posicao"
    :posicao_dois="posicao_dois"
    :posicao_tres="posicao_tres"
    :posicao_quatro="posicao_quatro"
    :posicao_cinco="posicao_cinco"/>

  <ModalApelido :isOpen="isModalOpen" @close="fecharModal" :dados="dadosgr"/>

  <div class="msg-alerta">
    <Message v-if="mostrar_msg" :severity="estilo">{{ msg }}</Message>
  </div>
  <loading-imgs v-if="loading"/>
  <div v-show="!loading" class="formulario-container">
    <div id="form_padrao">
      <div class="titulo_documentos" v-if="ehBarraEdicao()">
        <legend class="titulo_documentos">Dados Gerais</legend>
      </div>
      <form method="post" enctype="multipart/form-data"
            @submit.prevent="salvarFormularioSimples($event)">
        <div class="div-radio" v-if="!ehBarraEdicao()">
          <RadioCheck :dadosgr="dadosgr" :ativa_tipo_de_pessoa="ativa_radio" :checked_fisico="true"/>
        </div>
        <div class="container_cadastro_base formulario-padrao"
             :class="{'form_casado_ativo': dados.statusestadocivil_id === 2 || dados.statusestadocivil_id === 6}">
          <div class="cont-form">
            <div id="div1" class="divisoes-forms">
              <label class="label-titulo" for="nm_email">E-MAIL</label>
              <input type="email"
                     id="nm_email"
                     name="nm_email"
                     v-model.trim="dados.nm_email"
                     @change="verificaEmail(); verificarEmailCadastrado(dados.nm_email)"
                     @keydown.enter.prevent
                     class="input-form letra_minusculas"
                     :disabled="ehBarraEdicao()"
                     :style="desabilitadoClass"
                     placeholder="Insira seu e-mail válido"
                     tabindex="1"
                     required>

              <span v-show="val_email" class="span_retorno">
                                  E-mail inválido, por favor insira um e-mail valido.
                                </span>
              <span v-show="verifica_email" class="span_retorno">
                                  E-mail já cadastrado, por favor insira um e-mail valido.
                                </span>
            </div>

            <div id="div10" class="divisoes-forms" v-if="!ehBarraEdicao()">
              <label class="label-titulo" for="nm_email_confirmacao">CONFIRMAÇÃO DO
                E-MAIL</label>
              <input type="email"
                     id="nm_email_confirmacao"
                     name="nm_email_confirmacao"
                     @keydown.enter.prevent
                     @change="comparaEmail()"
                     v-model.trim="dados.nm_email_confirmacao"
                     class="input-form letra_minusculas"
                     placeholder="Insira seu e-mail novamente"
                     :style="desabilitadoClass"
                     tabindex="2"
                     required>
              <span v-show="comp_email" class="span_retorno">E-mails não confere</span>

            </div>

            <div id="div2" class="divisoes-forms" v-if="!ehalteracao">
              <label class="label-titulo" for="nm_senha">SENHA</label>
              <Password id="nm_senha"
                        name="nm_senha"
                        minlength="6"
                        maxlength="40"
                        @keydown.enter.prevent
                        class="input-form nm_senha letra_minusculas" placeholder="Digite sua senha"
                        v-model.trim="dados.nm_senha"
                        prompt-label="Digite sua senha"
                        weak-label="Fraca"
                        medium-label="Média"
                        strong-label="Forte"
                        toggle-mask
                        strong-regex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_])(?=.{6,})"
                        required>
                <template #header>
                  <h6>Digite sua senha</h6>
                </template>
                <template #footer>
                  <Divider/>
                  <p class="mt-2">Obrigatório ter na sua senha:</p>
                  <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5 !important;">
                    <li>Pelo menos uma minúscula</li>
                    <li>Pelo menos uma maiúscula</li>
                    <li>Pelo menos um numérico</li>
                    <li>Pelo menos um caracter Especial</li>
                    <li>Mínimo de 6 caracteres</li>
                  </ul>
                </template>
              </Password>
              <span class="span_retorno" id="password-status"></span>
            </div>

            <div id="div11" class="divisoes-forms" v-if="!ehBarraEdicao()">
              <label class="label-titulo" for="verifica_senha">CONFIRMAÇÃO DE SENHA</label>
              <input type="password"
                     id="verifica_senha"
                     name="verifica_senha"
                     class="input-form letra_minusculas"
                     placeholder="confirme sua senha"
                     @change="comparaSenha()"
                     :disabled="ehBarraEdicao()"
                     @keydown.enter.prevent
                     :style="desabilitadoClass"
                     v-model.trim="dados.verifica_senha"
                     tabindex="4"
                     required>
              <span v-show="comp_senha" class="span_retorno">Senhas não confere</span>
            </div>

            <div id="div3" class="divisoes-forms">
              <label class="label-titulo" for="nm">NOME</label>
              <input type="text"
                     id="nm"
                     name="nm"
                     @input="limparCampo(dados, 'nm')"
                     @change="validadorEntrada(dados.nm, $event, 3); toUpperCase(dados, 'nm')"
                     @keydown.enter.prevent
                     v-model.trim="dados.nm"
                     class="input-form"
                     placeholder="Insira seu nome completo"
                     autocomplete="off"
                     tabindex="5"
                     required>
              <span id="nm_span" class="span_retorno"></span>
            </div>

            <div class="divisoes-forms">
              <label class="label-titulo ap_apelido" for="nm_contato">NOME DE USUÁRIO
                <div class="text-right" @click="openModalApelido" v-if="ehBarraEdicao()"
                     v-html="'Alterar nome de usuário'"/>
              </label>
              <input
                  type="text"
                  id="nm_apelido"
                  name="nm_apelido"
                  v-model.trim="dados.nm_apelido"
                  @keydown.enter.prevent
                  @input="limparApelido(dados, 'nm_apelido')"
                  @change="validarApelido"
                  class="input-form"
                  placeholder="Digite seu nome de usuário"
                  tabindex="5"
                  required
                  autocomplete="off"
                  maxlength="15">
              <span id="span_nm_apelido" class="span_retorno"></span>
              <span v-if="!dados.nm_apelido && !verDescOrgao" class="span_retorno"
                    @mouseenter="verDescOrgaoEmissor('nm_apelido', true)"
                    @click="verDescOrgaoEmissor('nm_apelido', true)">
                Esse nome será exibido quando você ofertar um lance.
              </span>
              <span v-show="verDescOrgaoSelceionado['nm_apelido']" class="orgao_emissor"
                    @click="verDescOrgaoEmissor('nm_apelido', false)"
                    @mouseout="verDescOrgaoEmissor('nm_apelido', false)">
                O campo "Usuário" serve como um identificador exclusivo do usuário em nosso sistema.
                Ao fornecer um usuário único, você será reconhecido de forma distinta em todas as interações, incluindo
                lances em leilões e na geração de relatórios.
                Escolha um usuário que represente sua identidade de forma única e memorável.
                Este usuário será visível para outros usuários ao participar de leilões em nosso sistema.</span>
            </div>

            <div id="div4" class="divisoes-forms">
              <label class="label-titulo" for="nm_cpfoucnpj">CPF</label>
              <input type="tel"
                     id="nm_cpfoucnpj"
                     name="nm_cpfoucnpj"
                     v-model.trim="dados.nm_cpfoucnpj"
                     class="input-form"
                     v-mask="(dados.bn_pessoajuridica && ehBarraEdicao) ? '##.###.###/####-##' : '###.###.###-##'"
                     placeholder="Insira seu CPF"
                     autocomplete="off"
                     :disabled="ehBarraEdicao()"
                     :style="desabilitadoClass"
                     @change="validarCPF(dados.nm_cpfoucnpj, $event)"
                     @keydown.enter.prevent
                     tabindex="6"
                     required>
              <span v-show="cpf_existe" class="span_retorno">
                  CPF já cadastrado, por favor verificar seu CPF
                </span>
              <span id="cpf_principal_valida" class="span_retorno"></span>
            </div>

            <div id="div18" class="divisoes-forms">
              <label class="label-titulo" for="nm_profissao">PROFISSÃO</label>
              <input type="text"
                     id="nm_profissao"
                     name="nm_profissao"
                     v-model.trim="dados.nm_profissao"
                     @keydown.enter.prevent
                     @change="validadorEntrada(dados.nm_profissao, $event, 3), toUpperCase(dados, 'nm_profissao')"
                     class="input-form"
                     placeholder="Insira sua profissão atual"
                     required
                     tabindex="7">
              <span id="tipo_profissoes" class="span_retorno"></span>
              <span id="span_nm_profissao" class="span_retorno"></span>
            </div>

            <div id="div5" class="divisoes-forms">
              <label class="label-titulo" for="rg">RG</label>
              <input type="tel"
                     id="rg"
                     name="nm_rg"
                     v-model.trim="dados.nm_rgouie"
                     @keydown.enter.prevent
                     maxlength="20"
                     class="input-form"
                     placeholder="Insira o numero do rg" autocomplete="off" tabindex="7"
                     required>
              <span id="span_nm_rg" class="span_retorno"></span>
            </div>

            <div id="div15" class="divisoes-forms">
              <label class="label-titulo" for="orgao_emissao">ORGÃO EMISSOR</label>
              <input type="text"
                     id='orgao_emissao'
                     name="orgao_emissao"
                     @keydown.enter.prevent
                     v-model="dados.nm_orgaoemissor"
                     @change="toUpperCase(dados, 'nm_orgaoemissor')"
                     class="input-form"
                     placeholder="Insira o orgão emissor somente sigla"
                     maxlength="20"
                     required
                     tabindex="8">
              <span v-if="!dados.nm_orgaoemissor && !verDescOrgao"
                    class="span_retorno"
                    @mouseenter="verDescOrgaoEmissor('orgao_emissao', true)"
                    @click="verDescOrgaoEmissor('orgao_emissao', true)">
                    Informe somente sigla.
              </span>
              <span v-show="verDescOrgaoSelceionado['orgao_emissao']"
                    class="orgao_emissor"
                    @click="verDescOrgaoEmissor('orgao_emissao', false)"
                    @mouseout="verDescOrgaoEmissor('orgao_emissao', false)"
              >
                  A sigla do órgão expedidor pode variar entre estados, mas em muitos casos
                  quando a Secretaria de Segurança Pública está envolvida,
                  a sigla será (SSP) seguida da sigla do estado, como (SSP/SP) para São Paulo.</span>
            </div>

            <div id="div7" class="divisoes-forms">
              <label class="label-titulo" for="nm_pai">NOME DO PAI</label>
              <input type="text"
                     id="nm_pai"
                     name="nm_pai"
                     v-model.trim="dados.nm_pai"
                     @input="limparCampo(dados, 'nm_pai')"
                     @change="validadorEntrada(dados.nm_pai, $event, 3), toUpperCase(dados, 'nm_pai')"
                     @keydown.enter.prevent
                     class="input-form"
                     placeholder="Insira nome do seu pai"
                     autocomplete="off"
                     tabindex="9"
                     required>
              <span id="span_nm_pai" class="span_retorno"></span>
            </div>

            <div id="div17" class="divisoes-forms">
              <label class="label-titulo" for="profissao">NOME DA MÃE</label>
              <input type="text"
                     id="nm_mae"
                     name="nm_mae"
                     v-model.trim="dados.nm_mae"
                     @keydown.enter.prevent
                     class="input-form"
                     @input="limparCampo(dados, 'nm_mae')"
                     @change="validadorEntrada(dados.nm_mae, $event), toUpperCase(dados, 'nm_mae')"
                     placeholder="Insira nome da sua mãe"
                     tabindex="10"
                     required>
              <span id="span_nm_mae" class="span_retorno"></span>
            </div>


            <div class="div-divisao-rg-orgao div-estado">
              <div id="div13" class="divisoes-forms cidade">
                <label class="label-titulo" for="orgao_emissao">CIDADE NASCIMENTO</label>
                <input type="text"
                       id='nm_cidadenascimento'
                       name="nm_cidadenascimento"
                       v-model="dados.nm_cidadenascimento"
                       @change.capture="buscarEstados(), toUpperCase(dados, 'nm_cidadenascimento')"
                       @keydown.enter.prevent
                       class="input-form"
                       placeholder="Insira a cidade de nascimento"
                       tabindex="11"
                       required
                >
              </div>

              <div id="div14" class="divisoes-forms div-estadonascimento">
                <label class="label-titulo titulo-nascimento" for="nm_estadonascimento">ESTADO NASCIMENTO</label>
                <template v-if="this.dados.nm_cidadenascimento != null && this.dados.nm_cidadenascimento != ''">
                  <select
                      name="nm_estadonascimento"
                      v-model="dados.nm_estadonascimento"
                      v-on:select="estados"
                      id="nm_estadonascimento"
                      tabindex="12"
                      required
                  >
                    <option disabled selected="selected" hidden="hidden" value="">Selecione um estado</option>
                    <option
                        v-for="estado in estadonomesigla"
                        :key="estado.id"
                        :disabled="estado.disabled"
                        :selected="estado.selected"
                        :value="estado.sigla"
                        tabindex="12"
                    >
                      {{ estado.nm_sigla }}
                    </option>
                  </select>
                </template>
                <template v-else>
                  <select
                      name="nm_estadonascimento"
                      v-model="dados.nm_estadonascimento"
                      v-on:select="estados"
                      tabindex="12"
                      id="nm_estadonascimento"
                  >
                    <option disabled selected="selected" hidden="hidden" value="">Selecione um estado</option>
                    <option v-for="estado in estados"
                            tabindex="12"
                            :key="estado.id"
                            :selected="estado.selected"
                            :hidden="estado.hidden"
                            :disabled="estado.disabled"
                            :value="estado.sigla"
                    >
                      {{ estado.nome }} - {{ estado.sigla }}
                    </option>
                  </select>
                </template>
              </div>
            </div>

            <div id="div8" class="divisoes-forms">
              <label class="label-titulo" for="nm_pai">PAÍS DE ORIGEM</label>
              <select id="nm_nacionalidade"
                      name="nm_nacionalidade"
                      v-model="dados.nm_nacionalidade"
                      tabindex="13"
                      required>
                <option disabled selected="selected" hidden="hidden" value="">Selecione um país</option>
                <option v-for="pais in paisOrigemAll" :key="pais.nome"
                        :value="pais.nome">
                  {{ pais.nome }}
                </option>
              </select>
              <span id="span_nm_nacionalidade" class="span_retorno"></span>
            </div>

            <div id="div12" class="divisoes-forms">
              <label class="label-titulo" for="dt_nascimento">DATA DE NASCIMENTO</label>
              <input type="date"
                     id="dt_nascimento"
                     :value="formatarData(dados.dt_nascimento)"
                     @input="dados.dt_nascimento = $event.target.value"
                     @change.prevent="verificaIdade($event)"
                     @keydown.enter.prevent
                     name="dt_nascimento"
                     placeholder="dd/mm/aaaa"
                     tabindex="14"
                     required>
              <span v-show="verificaMaiorDeIdade" class="span_retorno">{{ texto_ref_idade }}</span>
            </div>

            <div id="div9" class="divisoes-forms">
              <label class="label-titulo" for="bn_sexo">SEXO</label>
              <select id="bn_sexo"
                      name="bn_sexo"
                      v-model.trim="dados.bn_sexo"
                      v-on:select="sexos"
                      tabindex="16"
                      required>
                <option v-for="sexo in sexos"
                        :key="sexo.id"
                        :selected="sexo.selected"
                        :hidden="sexo.hidden"
                        :disabled="sexo.disabled"
                        :value="sexo.tipo">
                  {{ sexo.sexo_user }}
                </option>
              </select>
            </div>

            <div id="div6" class="divisoes-forms">
              <label class="label-titulo" for="nm_celular">CELULAR</label>
              <input
                  id="nm_celular"
                  name="nm_celular"
                  v-mask="'(##) 9 ####-####'"
                  v-model.trim="dados.nm_celular"
                  @change="validadorEntrada(dados.nm_celular, $event, 15)"
                  @keydown.enter.prevent
                  class="input-form"
                  tabindex="17"
                  placeholder="Insira o número do celular"
                  required
              />
            </div>

            <div id="div6" class="divisoes-forms" v-if="!ehBarraEdicao()">
              <label class="label-titulo" for="nm_celular">CONFIRMAÇÃO DO CELULAR</label>
              <input
                  id="nm_celular_confirmacao"
                  name="nm_celular_confirmacao"
                  v-mask="'(##) 9 ####-####'"
                  v-model.trim="nm_celular_confirmacao"
                  @change="comparaCelular"
                  @keydown.enter.prevent
                  class="input-form"
                  tabindex="17"
                  placeholder="Confirme o número do celular"
                  required
              />
              <span v-show="compo_celular" class="span_retorno">Números não confere</span>
            </div>

            <div id="div16" class="divisoes-forms">
              <label class="label-titulo" for="nm_telefone">TELEFONE FIXO PARA
                CONTATO<strong>(opcional)</strong></label>
              <input
                  id="nm_telefone"
                  name="nm_telefone"
                  v-mask="'(##) ####-####'"
                  v-model.trim="dados.nm_telefone"
                  @keydown.enter.prevent
                  class="input-form"
                  placeholder="número do telefone"
                  tabindex="18"
              />
            </div>

            <div id="div19" class="divisoes-forms">
              <label class="label-titulo" for="statusestadocivil_id">ESTADO CIVIL</label>
              <select name="statusestadocivil_id"
                      v-model="dados.statusestadocivil_id"
                      v-on:select="estado_civies"
                      id="statusestadocivil_id"
                      required
                      tabindex="19">
                <option v-for="e_civil in estado_civies"
                        :selected="e_civil.selected"
                        :hidden="e_civil.hidden"
                        :disabled="e_civil.disabled"
                        :key="e_civil.id"
                        :value="e_civil.tipo">
                  {{ e_civil.estado_ci }}
                </option>
              </select>
            </div>
            <div id="div-aceites" v-if="!ehalteracao">
              <div class="divisoes-aceite">
                <input type="checkbox"
                       ref="termo"
                       @click.prevent="termo"
                       v-show="termoVisible"
                       id="bn_aceite_condicao_de_venda"
                       :title="titulo_condicao"
                       value="bn_aceite_condicao_de_venda"
                       name="bn_aceite_condicao_de_venda"
                       v-model="dados.bn_aceite_condicao_de_venda"
                       class="ac_condicoes"
                       tabindex="21" required>
                <label class="label-titulo" for="bn_aceite_condicao_de_venda"
                       title="clique aqui para ver a nossos termos e condições" @click="termo">
                  <a @click="abrirModalAceite(1)">
                    <span v-if="!this.termoVisible">Clique aqui para ver nossos Termos de Uso</span>
                    <span v-else>Declaro que li e aceito os Termos de Uso</span>
                  </a>
                </label>
              </div>

              <div class="divisoes-aceite">
                <input type="checkbox"
                       id="bn_politica_privacidade"
                       @click.prevent="privacidade"
                       v-show="politicaVisible"
                       :title="titulo_politica"
                       value="bn_politica_privacidade"
                       name="bn_politica_privacidade"
                       v-model="dados.bn_politica_privacidade"
                       class="bn_politica_privacidade"
                       tabindex="22"
                       ref="politica"
                       required>
                <label class="label-titulo" for="bn_politica_privacidade"
                       title="clique aqui para ver o termo de privacidade" @click="privacidade">
                  <a @click="abrirModalAceite(2)">
                    <span v-if="!this.politicaVisible">Clique aqui para ver nossa Política de privacidade</span>
                    <span v-else>Declaro que li e aceito a Política de Privacidade</span>
                  </a>
                </label>
              </div>

              <div class="divisoes-aceite">
                <input type="checkbox"
                       id="bn_politica_privacidade"
                       @click.prevent="adesao"
                       v-show="adesaoVisible"
                       :title="titulo_adesao"
                       v-model="this.adesaoVisible"
                       value="bn_politica_privacidade"
                       name="bn_politica_privacidade"
                       class="bn_politica_privacidade"
                       tabindex="22"
                       ref="adesao"
                       required>
                <label class="label-titulo" for="bn_adesao"
                       title="clique aqui para ver o termo de adesão" @click="adesao">
                  <a @click="abrirModalAceite(3)">
                    <span v-if="!this.adesaoVisible">Clique aqui para ver nossa Termo de Adesão</span>
                    <span v-else>Declaro que li e aceito o Termo de Adesão</span>
                  </a>
                </label>
              </div>

              <div class="divisoes-aceite" v-if="this.termoVisible && this.politicaVisible && this.adesaoVisible">
                <input type="checkbox"
                       id="confirma_declaracao"
                       :title="titulo_politica"
                       value="confirma_declaracao"
                       @keydown.enter.prevent
                       name="confirma_declaracao"
                       v-model="this.confirma_declaracao"
                       class="bn_politica_privacidade"
                       tabindex="22"
                       required>
                <label class="label-titulo" title="clique aqui para ver o termo de privacidade">Declaro ter conhecimento
                  e consentir que ao efetiver este cadastro meus dados são compartilhados com os leiloeiros franqueados
                  de acordo
                  com a Política de privacidade.
                </label>
              </div>
              <div class="msg-alerta-aceite" :class="{'shake': isShaking}" style="font-size: 14px; color:red"
                   v-if="!dados.bn_aceite_condicao_de_venda || !dados.bn_politica_privacidade  || !this.adesaoVisible">
                Campos obrigatórios! Por favor, aceite os termos e condições e a política de privacidade.
              </div>
            </div>
          </div>

          <div class="formulario-padrao"
               v-if="dados.statusestadocivil_id === 2 || dados.statusestadocivil_id === 6">
            <div class="form_casado" v-show="visivel">
              <div>
                <div class="cont-form-casado">
                  <div class="divisoes-forms-casado">
                    <label class="label-titulo" for="nm_conjuge">NOME DO CÔNJUGE</label>
                    <input type="text"
                           id="nm_conjuge"
                           name="nm_conjuge"
                           @keydown.enter.prevent
                           v-model="dados.nm_conjuge"
                           @input="limparCampo(dados, 'nm_conjuge')"
                           @change="validadorEntrada(dados.nm_conjuge, $event), toUpperCase(dados, 'nm_conjuge')"
                           class="input-form"
                           placeholder="Insira o nome completo"
                           tabindex="23"
                           required>
                    <span id="span_nm_conjuge" class="span_retorno"></span>
                  </div>

                  <div class="div-divisao-rg-orgao">
                    <div class="divisoes-forms-casado rg">
                      <label class="label-titulo" for="nm_rgconjuge">RG DO CÔNJUGE</label>
                      <input type="tel"
                             id='nm_rgconjuge'
                             name="nm_rgconjuge"
                             @keydown.enter.prevent
                             v-model="dados.nm_rgconjuge"
                             class="input-form"
                             maxlength="20"
                             placeholder="Insira RG do cônjuge"
                             tabindex="24"
                             required>
                      <span id="span_rg_conjuge" class="span_retorno"></span>
                    </div>

                    <div class="divisoes-forms-casado or">
                      <label class="label-titulo" for="nm_orgaoemissorconjuge">ORGÃO EMISSOR</label>
                      <input type="text"
                             id='nm_orgaoemissorconjuge'
                             name="nm_orgaoemissorconjuge"
                             @keydown.enter.prevent
                             v-model="dados.nm_orgaoemissorconjuge"
                             @change="toUpperCase(dados, 'nm_orgaoemissorconjuge')"
                             class="input-form"
                             placeholder="Insira o orgão emissor somente siglas"
                             maxlength="20"
                             required
                             tabindex="25">
                      <span v-if="!dados.nm_orgaoemissorconjuge && !verDescOrgao"
                            class="span_retorno"
                            @mouseenter="verDescOrgaoEmissor('nm_orgaoemissorconjuge', true)"
                            @click="verDescOrgaoEmissor('nm_orgaoemissorconjuge', true)">
                    Informe somente sigla.
              </span>
                      <span v-show="verDescOrgaoSelceionado['nm_orgaoemissorconjuge']"
                            class="orgao_emissor omc"
                            @click="verDescOrgaoEmissor('nm_orgaoemissorconjuge', false)"
                            @mouseout="verDescOrgaoEmissor('nm_orgaoemissorconjuge', false)"
                      >
                  A sigla do órgão expedidor pode variar entre estados, mas em muitos casos
                  quando a Secretaria de Segurança Pública está envolvida,
                  a sigla será (SSP) seguida da sigla do estado, como (SSP/SP) para São Paulo.</span>
                    </div>
                  </div>

                  <div class="divisoes-forms-casado">
                    <label class="label-titulo" for="nm_cpfconjuge">CPF DO CÔNJUGE</label>
                    <input type="tel"
                           id="nm_cpfconjuge"
                           name="nm_cpfconjuge"
                           v-model="dados.nm_cpfconjuge"
                           class="input-form"
                           @keydown.enter.prevent
                           v-mask="'###.###.###-##'"
                           placeholder="Insira o CPF do cônjuge"
                           @change="validarCPF(dados.nm_cpfconjuge, $event), comparacaoCampos(dados.nm_cpfconjuge, dados.nm_cpfoucnpj)"
                           tabindex="26"
                           :style="desabilitadoClass"
                           required>
                    <span id="cpf_invalido_conjuge" class="span_retorno"></span>
                    <span v-show="cpf_existe_conj" class="span_retorno">
                      CPF já cadastrado, por favor verificar CPF
                    </span>
                  </div>

                  <div class="divisoes-forms-casado">
                    <label class="label-titulo" for="nm_profissaoconjuge">PROFISSÃO DO CÔNJUGE</label>
                    <input type="text"
                           id="nm_profissaoconjuge"
                           name="nm_profissaoconjuge"
                           @keydown.enter.prevent
                           v-model="dados.nm_profissaoconjuge"
                           @change="validadorEntrada(dados.nm_profissaoconjuge, $event, 3), toUpperCase(dados, 'nm_profissaoconjuge')"
                           class="input-form"
                           placeholder="Insira a profissão do cônjuge"
                           tabindex="27"
                           required
                    >
                    <span id="span_nm_profissaoconjuge" class="span_retorno"></span>
                  </div>

                  <div class="divisoes-forms-casado">
                    <label class="label-titulo" for="nm_nacionalidadeconjuge">PAÍS DE ORIGEM DO CÔNJUGE</label>
                    <select id="nm_nacionalidadeconjuge"
                            name="nm_nacionalidadeconjuge"
                            v-model="dados.nm_nacionalidadeconjuge"
                            v-on:select="paisOrigemAll"
                            tabindex="18"
                            required>
                      <option disabled selected="selected" hidden="hidden" value="">Selecione um país</option>
                      <option v-for="pais in paisOrigemAll"
                              :key="pais.nome"
                              :value="pais.nome">
                        {{ pais.nome }}
                      </option>
                    </select>
                    <span id="span_nm_nacionalidadeconjuge" class="span_retorno"></span>
                  </div>

                  <div class="divisoes-forms-casado">
                    <label class="label-titulo" for="statustipocasamento_id">REGIME DO CASAMENTO</label>
                    <select id="statustipocasamento_id"
                            name="statustipocasamento_id"
                            v-model.trim="dados.statustipocasamento_id"
                            v-on:select="tipo_de_regime"
                            tabindex="29"
                            required>
                      <option v-for="regime in tipo_de_regime"
                              :key="regime.id"
                              :disabled="regime.disabled"
                              :selected="regime.selected"
                              :hidden="regime.hidden"
                              :value="regime.tipo">
                        {{ regime.tipo_regime }}
                      </option>
                    </select>
                  </div>

                  <div class="divisoes-forms-casado">
                    <label class="label-titulo" for="dt_casamento">DATA DO CASAMENTO</label>
                    <input type="date" id="dt_casamento"
                           :value="formatarData(dados.dt_casamento)"
                           @input="dados.dt_casamento = $event.target.value"
                           @change.prevent="verificaCasamento($event)"
                           @keydown.enter.prevent
                           name="dt_casamento"
                           placeholder="dd/mm/aaaa"
                           tabindex="30"
                           required>
                    <span v-show="verificaDtCasamento" class="span_retorno">{{ texto_ref_casamento }}</span>
                  </div>
                </div>
              </div>

              <div class="botoes-view-ocul">
                <div id="icone-ocul" @click="visivel = !visivel">
                  <span class="material-symbols-outlined">visibility_off</span>
                  ocultar
                </div>
              </div>
            </div>

            <div class="botoes-view-ocul">
              <div id="icone-view" @click="visivel = !visivel">
                <span class="material-symbols-outlined">visibility</span>
                view
              </div>
            </div>
          </div>
        </div>


        <div class="formulario-padrao divisoes-forms" v-show="ehalteracao">
          <div :title="primeiro_alterar_senha"
               class="botao botao-abre-modal" id="botao-altera-senha-modal">{{ btn_text_alterar_senha }}
          </div>
        </div>

        <Botao type="submit"
               :title="primeiro_passo_altera"
               v-show="!proximo && ehalteracao"
               :btn_text="btn_text_alteracao"/>

        <Botao type="submit"
               @click="startAnimation"
               :title="primeiro_passo"
               v-show="!ehalteracao && !proximo"
               :btn_text="btn_text"/>

        <router-link
            v-if="!ehalteracao"
            style="text-decoration: none"
            aria-label="link de acesso a próxima do cadastro"
            :to="{ name: 'endereco_id' }">
          <Botao type="submit"
                 :title="proximo_passo"
                 v-show="proximo"
                 :btn_text="btn_continuar"/>
        </router-link>

        <router-link
            v-if="ehalteracao"
            style="text-decoration: none"
            aria-label="link de acesso a próxima do cadastro"
            :to="{ name: 'endereco_idEdita' }">
          <Botao type="submit"
                 :title="proximo_passo"
                 v-show="proximo"
                 :btn_text="btn_continuar"/>
        </router-link>

        <div v-if="this.id_user !== '' && this.id_user !== undefined" v-show="!ehalteracao">
          <router-link
              style="text-decoration: none"
              aria-label="link de acesso a próxima do cadastro"
              :to="{ name: 'codigo_id' }">
            <Botao type="submit"
                   :title="proximo_passo"
                   v-show="proximo"
                   :btn_text="btn_continuar"/>
          </router-link>
        </div>

      </form>
    </div>
  </div>
</template>
<script>

import vueTitle from "@/components/shared/vue-title";
import Botao from "@/components/shared/Botao";
import BarraPassos from "@/components/shared/BarraPassos";
import RadioCheck from "@/components/shared/RadioCheck";
import axios from "axios";
import LoadingImgs from "@/components/shared/LoadingImgs.vue";
import UsuarioPessoaFisica from "@/domain/cadastro/pessoa-fisica/usuario-pessoa-fisica";
import caminhoGlobal from "@/router/caminho-global";
import mapaDeRotas from "@/router/caminho-urls";
import verificaForcaSenha from "@/domain/valida-senha-forte";
import ValidacaoForm from "@/domain/validacao-form";
import {validadorEmail} from "@/domain/validador-email";
import {VerificarTipoCPF} from "@/domain/validador-cpf-cnpj";
import {salvarCadastro} from "@/controllers/salvar-cadastro";
import {AtualizaCadastro} from "@/controllers/atualiza-cadastro";
import desabilitaCampos from "@/domain/desabilita-campos";
import {token} from "@/stores/auth";
import ModalApelido from "@/components/shared/ModalApelido.vue";
import salvarDocumentosOcr from "@/controllers/salvar-documentos-ocr";
import UppercaseMixins from "@/mixins/UppercaseMixins";
import DadosOCR from "@/mixins/DadosOCR";
import IndexedDB from "@/mixins/IndexedDB";
import HandleKeyPress from "@/mixins/HandleKeyPress";
import VerificarEmailCadastrado from "@/mixins/VerificarEmailCadastrado";
import MetodosIguais from "@/mixins/MetodosIguais";
import ModalAceites from "@/components/shared/ModalAceites";

export default {
  name: "Form-padrao",
  components: {
    ModalApelido,
    LoadingImgs,
    RadioCheck,
    Botao,
    BarraPassos,
    vueTitle,
    ModalAceites
  },
  props: ["dadosgr"],
  mixins: [UppercaseMixins, DadosOCR, IndexedDB, HandleKeyPress, VerificarEmailCadastrado, MetodosIguais],
  data() {
    return {
      ApiResponse: [],
      titulo_condicao: 'aceite dos temos de condição de vendas',
      titulo_politica: 'aceite das politicas de privacidade',
      titulo_adesao: 'aceite das Termo de adesão',
      primeiro_passo: 'concluir primeiro passo',
      primeiro_passo_altera: 'Salvar alteração de dados',
      proximo_passo: 'Ir para proximo etapa',
      btn_text: "CONCLUIR",
      btn_text_alteracao: "SALVAR ALTERAÇÃO",
      btn_continuar: "PRÓXIMA ETAPA",
      ativa_radio: null,
      estilo: null,
      comp_email: false,
      visivel: true,
      msg: null,
      checked: true,
      proximo: false,
      mostrar_msg: false,
      situacaoatual: 'active',
      posicao: '1',
      posicao_dois: '2',
      posicao_tres: '3',
      posicao_quatro: '4',
      posicao_cinco: '5',
      tamanho_auto: '',

      //preenchando os selectedOptions
      estado_civies: [
        {estado_ci: 'selecione seu estado civil', tipo: null, disabled: true, selected: true, hidden: true},
        {estado_ci: 'Solteiro(a)', tipo: 1},
        {estado_ci: 'Casado(a)', tipo: 2},
        {estado_ci: 'Divorciado(a)', tipo: 4},
        {estado_ci: 'Viúvo(a)', tipo: 5},
        {estado_ci: 'Separado Judicialmente', tipo: 3},
        {estado_ci: 'União Estável', tipo: 6},
      ],

      sexos: [
        {sexo_user: 'selecione seu sexo', tipo: null, disabled: true, selected: true, hidden: true},
        {sexo_user: 'Feminino', tipo: false},
        {sexo_user: 'Masculino', tipo: true},
      ],

      tipo_de_regime: [
        {tipo_regime: 'selecione tipo de regime', disabled: true, selected: true, hidden: true},
        {tipo_regime: 'Comunhão parcial de bens', tipo: 2},
        {tipo_regime: 'Comunhão universal de bens', tipo: 1},
        {tipo_regime: 'Separação de bens', tipo: 3}
      ],

      estados: [],
      estado_nome: [],
      estadonomesigla: [],
      estadonomesiglaOne: [],

      dados: new UsuarioPessoaFisica(),
      id_user: null,
      //validacoes
      cpf_invalido: false,
      cpf_principal_valida: false,
      cpf_existe: false,
      cpf_existe_conj: false,
      val_email: false,
      comp_senha: false,
      nm_celular_confirmacao: '',
      compo_celular: false,
      verifica_email: false,
      login_existe: false,
      rotas: new caminhoGlobal().index,
      url_base: new mapaDeRotas(),
      alteraSenha: false,
      ehalteracao: false,
      nm_senha_atual: '',
      nm_senha_nova: '',
      nm_senha_verifica_nova: '',
      nm_senha_atual_span: false,
      texto_senha_atual: '',
      senha_atual_style: '',
      senhaModalCompletadas: true,
      senhaModalErradaStyle: 'cursor: no-drop',
      btn_text_alterar_senha: 'alterar senha',
      primeiro_alterar_senha: 'click aqui para alterar senha',
      verificaMaiorDeIdade: false,
      verificaDtCasamento: false,
      texto_ref_casamento: '',
      texto_ref_idade: '',
      tituloCadastro: 'cadastro',
      filtro: '',
      loading: false,
      desabilitadoClass: '',
      forcaSenha: '',
      termoVisible: false,
      politicaVisible: false,
      declaracaoVisible: false,
      adesaoVisible: false,
      confirma_declaracao: '',
      isShaking: false,
      paisOrigemAll: [],
      verDescOrgao: false,
      verDescOrgaoSelceionado: {},
      retornoApiEstado: false,
      retornoApiPaisOrigem: false,
      arquivos: null,
      documentRes: {
        file: null,
        nome: null,
      },
      selfieRes: {
        file: null,
        nome: null,
      },
      isModalOpen: false,
      images: [],
      openModalAceite: false,
      tipoAceite: 1
    }
  },
  methods: {
    paisOrigem() {
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/paises')
          .then((response) => {
            const data = response.data;
            data.sort((a, b) => (a.nome > b.nome ? 1 : -1));

            const brasil = data.find(pais => pais.nome === 'Brasil');
            const outrosPaises = data.filter(pais => pais.nome !== 'Brasil');

            this.paisOrigemAll = [brasil, ...outrosPaises];
          }).catch((error) => {
        console.log(`${error.message} !Atenção, erro ao buscar países.`);
      });
    },

    buscarEstados() {
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
          .then(response => {
            this.estados = response.data.sort((a, b) => a.nome.localeCompare(b.nome));
            if (this.dados.nm_cidadenascimento !== null && this.dados.nm_cidadenascimento !== '') {
              let formatado = this.dados.nm_cidadenascimento.replace(/\s+/g, '-');
              let url_cidades = `https://servicodados.ibge.gov.br/api/v1/localidades/municipios/${formatado.normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`;
              axios.get(url_cidades)
                  .then(response => {
                    if (response.data.length == 0) {
                      return axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
                          .then(response => {
                            // Ordenar estados por nome
                            this.estados = response.data.sort((a, b) => a.nome.localeCompare(b.nome));

                            this.estadonomesigla = this.estados.map(item => ({
                              sigla: item.sigla,
                              nm_sigla: item.nome + ' - ' + item.sigla
                            }));
                          })
                          .catch(error => {
                            console.error('Erro ao obter estados:', error);
                          });
                    } else if (Array.isArray(response.data)) {
                      this.estados = response.data;
                      this.estadonomesigla = response.data.map(item => ({
                        sigla: item.microrregiao.mesorregiao.UF.sigla,
                        nm_sigla: item.microrregiao.mesorregiao.UF.nome + ' - ' + item.microrregiao.mesorregiao.UF.sigla
                      }));
                    } else {
                      this.estados = [response.data];
                      this.estadonomesigla = [{
                        sigla: response.data.microrregiao.mesorregiao.UF.sigla,
                        nm_sigla: response.data.microrregiao.mesorregiao.UF.nome + ' - ' + response.data.microrregiao.mesorregiao.UF.sigla
                      }];
                    }
                  })
                  .catch(error => {
                    this.estadonomesigla = 'Não encontrado';
                    this.estado_nome = 'Não encontrado';
                    error
                  });
            }
          })
          .catch(err => {
            err.message
          })
    },

    async verificaSenha() {
      const verifica = new verificaForcaSenha('nm_senha_atualiza');
      verifica.verificaSenhaCadastro(this.nm_senha_nova);
    },

    verificaIdade(e) {
      if (new ValidacaoForm(e.target.id).verificaMaiorIdade(this.dados.dt_nascimento) === false) {
        this.verificaMaiorDeIdade = true
        this.texto_ref_idade = 'idade inválida, necessário ser maior de idade'
        this.proximo = false
      } else {
        this.texto_ref_idade = ''
        this.verificaMaiorDeIdade = false
      }
    },
    verificaCasamento(data) {
      if (new ValidacaoForm(data.target.id).verificaDataCasamento(this.dados.dt_casamento) === false) {
        this.verificaDtCasamento = true;
        this.texto_ref_casamento = 'Data inválida, necessário ser igual ou menor que o dia Atual.'
      } else {
        this.texto_ref_casamento = ''
        this.verificaDtCasamento = false;
      }
    },
    async getConsultaUsuario() {
      this.loading = true;
      const response = this.dadosgr
      if (response !== undefined || response !== false) {
        this.dados = response;
        this.id_user = this.dados.id
        this.dados.nm_celular = this.dados.ddd_tel_celular + this.dados.tel_celular
        this.dados.nm_telefone = this.dados.ddd_tel_contato + this.dados.tel_contato
        this.tipo_pessoa = this.dados.bn_pessoajuridica
      } else {
        this.dados = []
      }
      this.loading = false;

      if (this.id_user) {
        this.ehalteracao = true;
        this.alteraSenha = true;
      }
      await this.getDadosOCR('PF')
    },

    validadorEntrada(dados, id, qtd) {
      new ValidacaoForm(id.target.id).validaCamposCadastroNomes(dados, qtd)
    },

    validarApelido() {
      if (!this.dados.nm_apelido || this.dados.nm_apelido.length < 3 || this.dados.nm_apelido.length > 15) {
        this.mensagem('error', 'Usuário deve ter entre 3 e 15 caracteres.', 5000, false);
        this.dados.nm_apelido = '';
      }
    },

    verificaCamposSenhas() {
      const Validador = new ValidacaoForm();

      if (this.nm_senha_nova && Validador.validaPassword(this.nm_senha_nova)
          && this.nm_senha_verifica_nova && Validador.validaPassword(this.nm_senha_verifica_nova)) {
        this.senhaModalErradaStyle = 'cursor: pointer';
        this.senhaModalCompletadas = false;
      } else {
        this.senhaModalErradaStyle = 'cursor: not-allowed';
        this.senhaModalCompletadas = true;
      }
    },

    async comparacaoCampos(primeiroId, segundoId) {
      const primeiro = document.getElementById('nm_cpfoucnpj');
      const segundo = document.getElementById('nm_cpfconjuge');

      if (primeiroId === segundoId) {
        primeiro.style.border = '2px solid red';
        segundo.style.border = '2px solid red';
        this.cpf_existe_conj = true;
        this.mensagem(
            'error',
            'Os campos CPF e CPF DO CÔNJUGE não podem ser iguais!',
            5000,
            false
        );
        this.proximo = false;
        return;
      } else {
        this.cpf_existe_conj = false;
        primeiro.style.border = '';
        segundo.style.border = '';
      }
    },

    validarSenha(senha) {
      const requisitos = [
        {regex: /[a-z]/, mensagem: "Pelo menos uma letra minúscula"},
        {regex: /[A-Z]/, mensagem: "Pelo menos uma letra maiúscula"},
        {regex: /[0-9]/, mensagem: "Pelo menos um número"},
        {regex: /[\W_]/, mensagem: "Pelo menos um caractere especial"},
        {regex: /.{6,}/, mensagem: "Mínimo de 6 caracteres"}
      ];

      const erros = requisitos.filter(req => !req.regex.test(senha)).map(req => req.mensagem);

      if (erros.length > 0) {
        this.mensagem('error', `A senha não atende aos seguintes critérios: ${erros.join(', ')}`, 5000, false);
        return false;
      }

      return true;
    },

    async salvarFormularioSimples(e) {
      e.preventDefault();
      const validador = new ValidacaoForm(e.target.id);

      if (this.dados.nm_senha && this.dados.nm_senha !== this.dados.nm_senha_atual) {
        if (!this.validarSenha(this.dados.nm_senha)) {
          this.proximo = false;
          return;
        }
      }

      if (this.dados.nm_senha && this.dados.verifica_senha && this.dados.nm_senha !== this.dados.verifica_senha) {
        this.mensagem('error', "As senhas não conferem!", 5000, false);
        this.proximo = false;
        return;
      }

      if (!validadorEmail(this.dados.nm_email) && this.dados.nm_email) {
        this.proximo = false;
        this.val_email = true;
        setTimeout(() => {
          this.val_email = false;
          this.dados.email = null;
        }, 5000);
      } else if (
          (this.dados.statusestadocivil_id === 1) &&
          validador.validaPassword(this.dados.nm_senha) === false ||
          validador.validaCamposCadastroNomes(this.dados.nm_celular, "validacao") === false ||
          validador.validaCamposCadastroNomes(this.dados.nm, "validacao") === false ||
          validador.validaCamposCadastroNomes(this.dados.nm_cpfoucnpj, "validacao") === false ||
          validador.validaCamposCadastroNomes(this.dados.bn_sexo, "validacao") === false ||
          validador.validaCamposCadastroNomes(this.dados.nm_email, "validacao") === false ||
          validador.validaCamposCadastroNomes(this.dados.nm_email_confirmacao, "validacao") === false ||
          validador.validaCamposCadastroNomes(this.dados.statusestadocivil_id, "validacao") === false ||
          (this.dados.statusestadocivil_id === 2 &&
              validador.validaCamposCadastroNomes(this.dados.nm_cpfconjuge, "validacao") === false ||
              validador.validaCamposCadastroNomes(this.dados.nm_conjuge, "validacao") === false ||
              validador.validaCamposCadastroNomes(this.dados.nm_nacionalidadeconjuge, "validacao") === false ||
              validador.validaCamposCadastroNomes(this.dados.nm_profissaoconjuge, "validacao") === false) ||
          this.confirma_declaracao === false ||
          this.dados.bn_aceite_condicao_de_venda === false ||
          this.dados.bn_politica_privacidade === false
      ) {
        this.proximo = false;
      }

      if (!validador.validaCamposCadastroNomes(this.dados.nm_apelido, 3, 15)) {
        this.proximo = false;
      }

      try {
        const isEditMode = this.ehBarraEdicao();
        const data = {
          bn_tipo_de_pessoa: 'pessoa_fisica',
          nm: this.dados.nm,
          nm_apelido: this.dados.nm_apelido,
          nm_senha: this.dados.nm_senha,
          bn_sexo: this.dados.bn_sexo,
          nm_nacionalidade: this.dados.nm_nacionalidade,
          nm_cidadenascimento: this.dados.nm_cidadenascimento,
          nm_estadonascimento: this.dados.nm_estadonascimento,
          nm_rgouie: this.dados.nm_rgouie,
          nm_cpfoucnpj: this.dados.nm_cpfoucnpj,
          nm_email: this.dados.nm_email,
          nm_email_confirmacao: this.dados.nm_email_confirmacao,
          dt_nascimento: this.formatarData(this.dados.dt_nascimento),
          nm_orgaoemissor: this.dados.nm_orgaoemissor,
          nm_celular: this.dados.nm_celular,
          nm_telefone: this.dados.nm_telefone,
          nm_profissao: this.dados.nm_profissao,
          nm_pai: this.dados.nm_pai,
          nm_mae: this.dados.nm_mae,
          statusestadocivil_id: this.dados.statusestadocivil_id,
          nm_conjuge: this.dados.nm_conjuge,
          nm_rgconjuge: this.dados.nm_rgconjuge,
          nm_orgaoemissorconjuge: this.dados.nm_orgaoemissorconjuge,
          nm_cpfconjuge: this.dados.nm_cpfconjuge,
          nm_profissaoconjuge: this.dados.nm_profissaoconjuge,
          nm_nacionalidadeconjuge: this.dados.nm_nacionalidadeconjuge,
          statustipocasamento_id: this.dados.statustipocasamento_id,
          dt_casamento: this.formatarData(this.dados.dt_casamento),
          verifica_senha: this.dados.verifica_senha
        };

        if (data.nm_celular !== this.nm_celular_confirmacao && !this.ehBarraEdicao()) {
          this.mensagem(
              'error',
              'CELULAR e CONFIRMAÇÃO DO CELULAR, Números não confere.',
              5000,
              false
          );
          return;
        }

        if (data.statusestadocivil_id === 2) {
          const primeiro = document.getElementById('nm_cpfoucnpj');
          const segundo = document.getElementById('nm_cpfconjuge');

          if (data.nm_cpfoucnpj === data.nm_cpfconjuge) {
            primeiro.style.border = '2px solid red';
            segundo.style.border = '2px solid red';
            this.cpf_existe_conj = true;
            this.mensagem(
                'error',
                'Os campos CPF e CPF DO CÔNJUGE não podem ser iguais!',
                5000,
                false
            );
            this.proximo = false;
            return;
          } else {
            this.cpf_existe_conj = false;
            primeiro.style.border = '';
            segundo.style.border = '';
          }
        }

        const dt_cadastro = await this.dadosgr.dt_cadastro || '';
        const dt_cadastro_parts = dt_cadastro.split(" ");
        const dt_cadastro_form = dt_cadastro_parts.length > 0 ? dt_cadastro_parts[0].slice(0, 10) : '';

        if (dt_cadastro_form && isEditMode) {
          if (dt_cadastro_form < '2023-07-25') {
            data.etapa = 1;
          }
        }

        if (!isEditMode) {
          data.etapa = 1;
          data.nm_senha = this.dados.nm_senha;
          data.verifica_senha = this.dados.verifica_senha;
          data.bn_aceite_condicao_de_venda = this.dados.bn_aceite_condicao_de_venda;
          data.bn_politica_privacidade = this.dados.bn_politica_privacidade;
        } else {
          data.id = this.id_user;
        }

        if (this.dados.bn_aceite_condicao_de_venda) {
          data.bn_aceite_condicao_de_venda = this.dados.bn_aceite_condicao_de_venda;
        }

        if (this.dados.bn_politica_privacidade) {
          data.bn_politica_privacidade = this.dados.bn_politica_privacidade;
        }

        if (this.confirma_declaracao) {
          data.confirma_declaracao = this.confirma_declaracao
        }


        for (var key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key)) {
            if (data[key] === '' || data[key] === undefined || data[key] === null) {
              data[key] = null;
            }
          }
        }

        if (this.ehBarraEdicao()) {

          for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
              if (data[key] === '' || data[key] === undefined || data[key] === null) {
                // Remova o campo se for nulo, undefined ou uma string vazia
                delete data[key];
              }
            }
          }

          this.loading = true;
          const response = await AtualizaCadastro(data)
          this.loading = false;
          if (response.status === 400) {
            this.mensagem(
                'error',
                `${response.data}`,
                null,
                false
            );
          } else {
            if (dt_cadastro_form && isEditMode) {
              this.mensagem(
                  'success',
                  `Cadastro atualizado com sucesso!`,
                  5000,
                  true,
                  1
              );

              setTimeout(() => {
                localStorage.removeItem('apiResponse')
                localStorage.removeItem('apiResponseComprovante')
                localStorage.removeItem('apiResponse_FACE_ID')
                window.location.reload();
              }, 200);
              return
            } else {
              this.mensagem(
                  'success',
                  `Cadastro atualizado com sucesso!`,
                  5000,
                  true,
                  2
              );
            }
          }
          this.id_user = response.id
          return
        }

        // Verifica a força da senha
        this.forcaSenha = this.verificaSenha(e, data.nm_senha)
        if (this.forcaSenha) {
          this.loading = true;
          const response = await salvarCadastro(data)
          this.loading = false;

          if (response.status === 201) {
            if (process.env.VUE_APP_NODE_ENV === 'development') {
              await token(data.nm_email, data.nm_senha);
            }

            this.mensagem(
                'success',
                'Cadastro realizado com sucesso!',
                5000,
                true,
                2
            );

            desabilitaCampos();

            this.id_user = response.data.id;
            this.loading = true;
            await salvarDocumentosOcr(await this.getImagesFromIndexedDB(), this.id_user, 'PF')
            setTimeout(() => {
              window.location.reload();
            }, 300);
            this.loading = false;
          } else if (response.response.status === 400) {
            const dados = response.response.data;
            const inputSelector = 'input, select, textarea';
            const inputs = document.querySelectorAll(inputSelector);
            const errorClass = 'span_retorno';

            const existingErrorMessages = document.querySelectorAll(`.${errorClass}`);
            existingErrorMessages.forEach((element) => {
              element.remove();
            });

            const errorMessages = {
              sem_sobrenome: 'Sobrenome Obrigatório',
              email_existe: 'Email já existente',
              email_invalido: 'Email inválido',
              cpfcnpj_existe: 'CPF ou CNPJ existente',
              cnpj_invalido: 'CPF ou CNPJ inválido',
              stringLengthTooShort: 'Limite de caracteres não atingido',
              isEmpty: 'Campo obrigatório',
              notInArray: 'Campo obrigatório',
              apelido_caracter_invalido: 'Campo não suporta números',
              notMatch: 'Senhas não coincidem',
              emailAddressInvalidHostname: 'Endereço de Email inválido',
              apelido_existe: `${data.nm_apelido}, Usuário já existe`,
              apelido_invalido: `${data.nm_apelido}, Usuário já existe`,
            };

            for (const key in dados) {
              const inputElement = document.getElementById(key);

              if (inputElement && Array.isArray(dados[key]) && dados[key].length > 0) {
                const messageElements = document.querySelectorAll(`[data-input="${key}"]`);
                messageElements.forEach((messageElement) => {
                  messageElement.remove();
                });

                const errorCodes = dados[key];
                const errorMessagesForKey = errorCodes.map((errorCode) => errorMessages[errorCode]);

                if (errorMessagesForKey.length > 0) {
                  const messageElement = document.createElement('span');
                  messageElement.textContent = errorMessagesForKey.join('');
                  messageElement.style.color = 'red';
                  messageElement.style.fontSize = '14px';
                  messageElement.classList.add(errorClass);
                  messageElement.setAttribute('data-input', key);
                  inputElement.insertAdjacentElement('afterend', messageElement);
                }
              }
            }

            inputs.forEach((input) => {
              input.addEventListener('input', () => {
                const id = input.getAttribute('id');
                const messageElements = document.querySelectorAll(`[data-input="${id}"]`);
                messageElements.forEach((messageElement) => {
                  messageElement.remove();
                });
              });
            });

            this.loading = false;
            this.tipo_pessoa = true;
            this.dados.nm_senha = null;
            this.dados.verifica_senha = null;
            this.forcaSenha = null;

            this.mensagem(
                'error',
                'Desculpe, algo deu errado. Por favor, verifique seus dados.',
                5000,
                false
            );
          }
        } else {
          this.dados.nm_senha = null;
          this.dados.verifica_senha = null;
          this.forcaSenha = null;
          this.mensagem(
              'error',
              'Para sua segurança crie uma senha segura, ' +
              'Senha maior que 6 caracteres com LETRAS, NÚMEROS, CARACTERES ESPECIAIS, exemplo: @MinhaSenha$123',
              50000,
              false);
        }

      } catch (error) {
        this.mensagem(
            'error',
            `Desculpe algo deu errado, não se preocupe o erro é interno, atualize a página e tente novamente.`,
            null,
            false
        );
      }
    },

    validarCPF(numero_cpf, e) {
      if (e.target.id === 'nm_cpfconjuge') {
        new VerificarTipoCPF(numero_cpf, e.target.id, this.dados.nm_cpfconjuge)
      } else {
        new VerificarTipoCPF(numero_cpf, e.target.id, this.dados.nm_cpfoucnpj)
      }
    },

    verificaEmail() {
      if (!validadorEmail(this.dados.nm_email) && this.dados.nm_email != "") {
        this.val_email = true
      } else {
        this.proximo = false
        this.val_email = false
      }
    },
  },

  created() {
    this.getDadosOCR('PF')
    this.paisOrigem();
    this.buscarEstados();
    this.getConsultaUsuario();
    window.addEventListener('keydown', this.handleKeyPress);
  },

  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyPress);
  },

  mounted() {
    this.getDadosOCR('PF');
    const fechaSenha = document.getElementById('fechaModalAletacaoSenha')
    fechaSenha.addEventListener('click', () => {
      const fechaModal = document.getElementById('modal-comprovante')
      fechaModal.classList.add('none');
    })

    const abreSenha = document.getElementById('botao-altera-senha-modal')
    abreSenha.addEventListener('click', () => {
      const abreSenhaModal = document.getElementById('modal-comprovante')
      abreSenhaModal.classList.remove('none');
    })

    const senha = document.querySelector('.nm_senha');

    if (senha) {
      senha.children[0].setAttribute('tabindex', '3');
    }

    return (this.id_user != null) ? this.tituloCadastro = 'Editar Cadastro | Pessoa Física' : this.tituloCadastro;
  }
}
</script>

<style scoped>
select#nm_nacionalidade {
  width: 100%;
}

.container_cadastro_base {
  margin: auto;
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  flex-direction: column;
}

.form_casado_ativo {
  flex-direction: inherit !important;
}

.modal-comprovante button {
  float: right;
  font-size: 20px;
  font-weight: 900;
  padding: 15px;
  background: var(--bd-primary);
  border: none;
  color: var(--color-base);
  border-radius: 25px;
  margin: initial !important;
  position: unset;
  animation: mymove;
  animation-duration: 0.5s;
}

.input-erro {
  border: 1px solid red;
}
</style>